import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from "react-router-dom";
import users from "../../Utils/UserList.json";
import { interstedMatch } from "../../Services/api";
import { ToastContainer, toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";


const VerifiedProfile = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

  useEffect(() => {
    setData(users); // Load JSON data into state
  }, []);

    const handleEdit = (rowData) => {
    //navigate(`/user-form/${rowData.name}`, { state: { user: rowData } });
  };

  // const handleAdd = () => {
  //   navigate("/user-form");
  // };

  const getIntersted = async () => {
      setLoading(true);
      try {
        const result = await interstedMatch();
        setData(result.data);
        
        console.log(result);
      } catch (error) {
        setLoading(false);
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
      //setData(users); // Load JSON data into state
      getIntersted();
    }, []);

  const columns = [
    { name: "name", label: "Liked By",
      options: {
        customBodyRender: (value, tableMeta) => {
          const name = data[tableMeta.rowIndex].likedBy.name;
                    const Email = data[tableMeta.rowIndex].likedBy.email;
          const Phone = data[tableMeta.rowIndex].likedBy.mobile;

          return `Name: ${name}, Email: ${Email}, Phone: ${Phone}`;
        }
      }
     },

    { name: "name", label: "Liked To",
      options: {
        customBodyRender: (value, tableMeta) => {
          const name = data[tableMeta.rowIndex].likedTo.name;
                    const Email = data[tableMeta.rowIndex].likedTo.email;
          const Phone = data[tableMeta.rowIndex].likedTo.mobile;

          return `Name: ${name}, Email: ${Email}, Phone: ${Phone}`;
        }
      }
     },

     
  ];


  const options = {
    filterType: "checkbox",
    print: "false",
    download: "false",
    viewColumns: "false",
    filter: false,
    selectableRows: false,
    // customToolbar: addButton,
  };

  return (
    <>
      {loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          {/* <ToastContainer autoClose={1000} /> */}
          <MUIDataTable
            title={"Intersted Match List"}
            data={data}
            columns={columns}
            options={options}
          />
        </>
      )}
    </>
  );
};

export default VerifiedProfile;
